import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=28ec4fca&scoped=true"
import script from "./Story.vue?vue&type=script&lang=ts"
export * from "./Story.vue?vue&type=script&lang=ts"
import style0 from "./Story.vue?vue&type=style&index=0&id=28ec4fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec4fca",
  null
  
)

export default component.exports